import { render, staticRenderFns } from "./NshopStatistics.vue?vue&type=template&id=10183868&scoped=true&"
import script from "./NshopStatistics.vue?vue&type=script&lang=js&"
export * from "./NshopStatistics.vue?vue&type=script&lang=js&"
import style0 from "./NshopStatistics.vue?vue&type=style&index=0&id=10183868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10183868",
  null
  
)

export default component.exports